import { render } from "./Lgthirteen.vue?vue&type=template&id=468e8c40&scoped=true"
import script from "./Lgthirteen.vue?vue&type=script&lang=js"
export * from "./Lgthirteen.vue?vue&type=script&lang=js"

import "./Lgthirteen.vue?vue&type=style&index=0&id=468e8c40&scoped=true&lang=css"

import exportComponent from "E:\\NC\\services\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-468e8c40"]])

export default __exports__